var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTune(_ref) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M423.609-106.999V-345h73v83h353v73.001h-353v82h-73Zm-313.218-82V-262h260v73.001h-260Zm187-172.783v-82h-187v-72.436h187v-84h73v238.436h-73Zm126.218-82v-72.436h426v72.436h-426Zm166-171.218v-238.001h73v82h187V-698h-187v83h-73Zm-479.218-83v-73.001h426V-698h-426Z"
  })));
}
export default __webpack_public_path__ + "media/outlined/tune-0a584390.svg";
export { SvgTune as ReactComponent };